<div class="content-container">
  <div [ngClass]="{ 'disabled-content': disabled$ }" class="tinymce-editor">
    <form [formGroup]="workflowForm">
      <editor
        id="postEditing"
        [formControlName]="'postFinal'"
        [init]="getTinyMCEConfig()"
      >
      </editor>
    </form>
  </div>
  <div *ngIf="disabled$" class="overlay-message">
    We are currently regenerating your post based on your adjustments...
  </div>
</div>
